// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../assets/stylesheets/variables.css\"","customWhite":"#ffffff","body":"_2lYHSCAcM6vA2s-47YYZeS","caption":"_1dJD2pSCq2-UhXWE_3mRfd","dropdownZIndex":"1","lightGrey":"#fcfcfc","borderGrey":"#d5dfdf","container":"_2nFgvu5i-wuJTE4nbT7pgk","dropdown":"_3TPAVizXiPi-_7oXZKU7rE","suggestion":"_33yGARK8ReggIbyZYsszqO _1dJD2pSCq2-UhXWE_3mRfd","spinner":"_3c6B_sj6Sx_pxADEVCvJye","spinnerImage":"_1lVFsYzovb_QIGmPVPeSQF"};


//////////////////
// WEBPACK FOOTER
// ./src/common/street-autocomplete-input/StreetAutocompleteInput.css
// module id = 453
// module chunks = 0 1 2